import { render } from "./ApplyHeader.vue?vue&type=template&id=baf79742"
import script from "./ApplyHeader.vue?vue&type=script&lang=js"
export * from "./ApplyHeader.vue?vue&type=script&lang=js"

import "./ApplyHeader.vue?vue&type=style&index=0&id=baf79742&lang=less"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__